<template>
	<div class="container">
		<div class="header">
			<div class="header-left">
				<img class="header-left-img" src="../assets/logo.png" alt=""/>
				<img class="header-left-img1" src="../assets/image/youxiu_logo_wenzi@2x.png" alt=""/>
			</div>
			<div class="sousuo" v-if="$store.state.count == 2">
				<div class="sousuo-box">
					<input class="box-input-input" v-model="content" type="text" :placeholder="$t('all.sousuoniganxingqudeneirong')" placeholder-style="color:rgba(255,255,255,0.6)" autocomplete="off"/>
					<div class="sousuo-right" @click="handleSearchInput">
						<div class="sousuo-right-xian"></div>
						<img class="sousuo-right-img" src="../assets/image/sousuo_18@2x.png" alt=""/>
						<span class="sousuo-right-span">{{$t('all.sousuo')}}</span>
					</div>
				</div>
			</div>
			<div class="header-right">
				<div class="header-right-item" @click="handleShowModalVisible(4)">
					<img  src="../assets/image/appxiazai.png" alt=""/>
					<span>{{$t('all.appxiazai')}}</span>
				</div>
				<div class="header-right-item" @click="handleShowModalVisible(1)">
					<img  src="../assets/image/xitongxiaoxi_18_1@2x.png" alt=""/>
					<span>{{$t('all.xitongxiaoxi')}}</span>
				</div>
				<div class="header-right-item" @click="handleShowModalVisible(2)">
					<img src="../assets/image/wodedingdan_1@2x.png" alt=""/>
					<span>{{$t('all.wodedingdan')}}</span>
				</div>
				<div class="header-right-item" @click="handleShowModalVisible(3)">
					<img src="../assets/image/bangzhufankui_1@2x.png" alt=""/>
					<span>{{$t('all.bangzhufankui')}}</span>
				</div>
				<img v-if="$store.state.userInfo" class="header-right-img" :src="$store.state.userInfo.headPortrait" alt="" @error="handleImgError" @click="handleTiaozhuan"/>
			</div>
		</div>
		<div class="main">
			<aside class="menu-expanded">
				<div class="aside-box" >
					<div
					v-for="(item,index) in $router.options.routes" 
					v-if="!item.hidden" 
					@click="handlerouter(index,item)"
					:class="$store.state.count===index?'active-aside-box-item':'aside-box-item'"
					>
						<img class="icon" v-if="$store.state.count != index" :src="item.iconCls" alt="" />
						<img class="icon" v-if="$store.state.count == index" :src="item.selectedIconCls" alt="" />
						<span :class="$store.state.count === index?'aside-box-item-span':'aside-box-item-span1'">{{$store.state.language==='chinese'?item.children[0].meta.CnName :$store.state.language==='english'?item.children[0].meta.EnName:item.children[0].meta.TwName}}</span>
					</div>
				</div>
				<div class="aside-bottom">
					<img src="../assets/image/wode_sz@2x.png" @click="handleShowSz" alt=""/>
					<img src="../assets/image/tuichu@2x.png" alt="" @click="handleShowTc"/>
				</div>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container"></el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
				<div class="custom-bg-bottom">
					<div class="custom-bg-bottom-xy">
						<span @click="handleShowModel(1)">{{$t('all.yonghuxieyi')}}</span>
						<span @click="handleShowModel(2)">{{$t('all.yinsixieyi')}}</span>
							<span @click="handleShowXiazai">{{$t('all.appxiazai')}}</span>
					</div>
					<div class="custom-bg-bottom-des">COPYRIGHT © 2026 WWW.UNISHOW.LIVE</div>
				</div>
			</section>
		</div>
		<!-- 遮罩层和弹窗 -->
		<div class="modal-overlay" v-if="isModalVisible" @click="isModalVisible = false"></div>
		<div class="modal-overlay-content" v-if="isModalVisible">
			<xitongxiaoxi v-if="type == 1"/>
			<wodedingdan v-if="type == 2"/>
			<wentibangzhu v-if="type == 3" @uploadFk="handleUploadFk"/>
			<appxiazai v-if="type == 4"/>
		</div>
		
		
		<div class="modal-overlay-fk" v-if="isFkModalVisible" @click="isFkModalVisible = false"></div>
		<div class="modal-overlay-content-fk" v-if="isFkModalVisible">
			<woyaofankui @closeFk="isFkModalVisible = false"/>
		</div>
		<shezhi ref="sz"></shezhi>
		<tuichudenglu ref="tc"></tuichudenglu>
		<xieyi ref="xieyi"/>
		<xiazai ref="xiazai"/>
	</div>
</template>

<script>
import xitongxiaoxi from "../components/xitongxiaoxi/xitongxiaoxi.vue"
import wodedingdan from "../components/wodedingdan/wodedingdan.vue"
import wentibangzhu from "../components/wentibangzhu/wentibangzhu.vue"
import woyaofankui from "../components/woyaofankui/woyaofankui.vue"
import shezhi from "../components/shezhi/shezhi.vue"
import tuichudenglu from "../components/tuichudenglu/tuichudenglu.vue"
import appxiazai from "../components/appxiazai/appxiazai.vue"
import xiazai from "../components/xiazai/xiazai.vue"
import xieyi from "../components/xieyi/xieyi.vue"
	export default {
		components: {
		  xitongxiaoxi,
		  wodedingdan,
		  wentibangzhu,
		  woyaofankui,
		  shezhi,
		  tuichudenglu,
		  appxiazai,
		  xiazai,
		  xieyi
		},
		data() {
			return {
				isModalVisible:false,
				content:null,
				type:'',
				isFkModalVisible:false,
				defaulImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
			}
		},
		mounted() {
			console.log(this.$router.options.routes,'$router.options.routes')
			this.$store.commit('changeSearchQuery', null);
		},
		methods: {
			goBack() {
				this.$router.go(-1);
            },
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('user');
					_this.$router.push('/login');
				}).catch(() => {

				});
			},
			handlerouter(index,item){
				this.$store.commit('changeCount', index); // 调用 setCount mutation 并传递参数
				this.$router.push(item.children[0].path)
			},
			//处理搜索框输入事件
			handleSearchInput() {
				// 将输入框的内容提交到 Vuex store
				this.$store.commit('changeSearchQuery', this.content?this.content:null);
			},
			//显示弹框
			handleShowModalVisible(data){
				this.isModalVisible = true
				this.type = data
			},
			//我要反馈
			handleUploadFk(){
				this.isModalVisible = false
				this.isFkModalVisible = true
			},
			//显示设置
			handleShowSz(){
				this.$refs.sz.showModel()
			},
			//显示退出登录
			handleShowTc(){
				this.$refs.tc.showModel()
			},
			handleImgError(e) {
			    // e.target 指向加载失败的 img 元素，替换其 src 为默认图片
			    e.target.src = this.defaultImg;
			    // 可选：防止默认图片也加载失败时无限触发 onerror 事件
			    e.target.onerror = null;
			},
			//协议
			handleShowModel(data){
				this.$refs.xieyi.showModel(data)
			},
			//显示下载弹框
			handleShowXiazai(){
				this.$refs.xiazai.showModel()
			},
			//跳转我的页面
			handleTiaozhuan(){
				this.$router.replace({ path: '/wode' });
			}
		},
		mounted() {
			var user = sessionStorage.getItem('user');

		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		background: #161823;
		.main {
			width: 100%;
			display: flex;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 158px;
				width: 158px;
				overflow-y: auto;
				overflow-x: hidden;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}
				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 158px;
				width: 158px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.el-menu-vertical-demo{
					width:100% !important;
				}
			}
			.content-container {
				flex:1;
				overflow-y: auto;
				
                /* --- 开始：新增的隐藏滚动条样式 --- */
                /* Firefox */
                scrollbar-width: none;
                /* IE and Edge */
                -ms-overflow-style: none;
			}
            /* Chrome, Safari, Opera */
            .content-container::-webkit-scrollbar {
                display: none;
            }
            /* --- 结束：新增的隐藏滚动条样式 --- */
		}
	}
	.el-message-box__message p {
		margin-left: -1px;
	}
	.header{
		height: 60px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 0px 24px;
	}
	.header-left{
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 350px;
	}
	.header-left-img{
		width: 38px;
		height: 38px;
	}
	.header-left-img1{
		padding-left: 8px;
		width: 85px;
	}
	.header-right{
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 350px;
		z-index: 1001;
	}
	.header-right-item{
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 28px;
		cursor: pointer;
	}
	.header-right-item img{
		width: 18px;
	}
	.header-right-item span{
		padding-top: 4px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: rgba(255,255,255,0.6);
		line-height: 16px;
	}
	.header-right-img{
		width: 38px;
		height: 38px;
		object-fit: cover;
		border-radius: 50%;
		cursor: pointer;
	}
	.aside-box{
		padding-top: 9px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.aside-box-item{
		width: 128px;
		height: 40px;
		background: #161823;
		border-radius: 20px 20px 20px 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-bottom: 32px;
		cursor: pointer;
	}
	.icon{
		width: 22px;
		height: 22px;
	}
	.active-aside-box-item{
		width: 128px;
		height: 40px;
		background: #2D2F38;
		border-radius: 20px 20px 20px 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-bottom: 32px;
		cursor: pointer;
	}
	.aside-box-item-span{
		padding-left: 12px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 17px;
		color: #FFFFFF;
		line-height: 23px;
	}
	.aside-box-item-span1{
		padding-left: 12px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 17px;
		color: rgba(255,255,255,0.6);
		line-height: 23px;
	}
	.sousuo{
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.sousuo-box{
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 80%;
		height: 42px;
		background: rgba(255,255,255,0.2);
		border-radius: 21px 21px 21px 21px;
		border: 1px solid rgba(255,255,255,0.2);
		padding: 0px 20px;
	}
	.sousuo input{
		border: none;
		outline: none;
		background: none;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: rgba(255,255,255,1);
		line-height: 21px;
		width: 100%;
		padding-right: 20px;
		flex: 1;
	}
	.sousuo-right{
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
	}
	.sousuo-right-xian{
		width: 0px;
		height: 20px;
		border: 1px solid rgba(255,255,255,0.5);
	}
	.sousuo-right-img{
		margin: 0px 10px;
		width: 18px;
	}
	.sousuo-right-span{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 21px;
	}
	.modal-overlay {
	    position: fixed;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    z-index: 1000; /* 设置一个高的 z-index */
	}
	
	.modal-overlay-content {
	    z-index: 1001;
	    position: fixed;
	    top: 60px;
	    right: 20px;
		height: calc(100vh - 260px);
	}
	
	.modal-overlay-fk {
	    position: fixed;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    z-index: 1000; /* 设置一个高的 z-index */
		background-color: rgba(0, 0, 0, 0.5);
	}
	
	.modal-overlay-content-fk {
	    z-index: 1001;
	    position: fixed;
	    top: 50%;
	    left: 50%;
	    transform: translate(-50%, -50%);
	    width: 600px;
	    background: #252632;
	    box-shadow: 0px 4px 48px 0px #0D0E16;
	    border-radius: 20px;
		padding: 20px 30px;
	}
	.aside-bottom{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 0px 40px 30px 40px;
	}
	.aside-bottom img{
		width: 22px;
		cursor: pointer;
	}
	.custom-bg-bottom{
		width: 100%;
		height: 66px;
		background: #161823;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.custom-bg-bottom-xy{
		display: flex;
		flex-direction: row;
	}
	.custom-bg-bottom-xy span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #ffffff;
		padding: 0px 20px;
		cursor: pointer;
	}
	.custom-bg-bottom-des{
		padding-top: 6px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		font-weight: 500;
	}
</style>


// WEBPACK FOOTER //
// Home.vue?73f18028